<template>
  <div>
    <v-pagination
      v-model="pageNum"
      :length="pages"
      :total-visible="5"
      circle
      color="success"
      class="mt-4"
    />
    <v-list three-line shaped height="710">
      <v-list-item-group
        :mandatory="experiments && experiments.length > 0"
        color="success"
        v-model="selected"
      >
        <v-list-item v-for="item in experiments" :key="item.id" :value="item">
          <v-list-item-content>
            <v-list-item-subtitle class="text-caption grey--text mb-0 pb-0">
              {{ item.sn }}
            </v-list-item-subtitle>
            <v-list-item-title class="black--text">
              {{ item.title }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-caption black--text">
              {{ dateFormat(new Date(item.start), 'MM月DD日 hh:mm') }}
              /
              {{ item.person }}
              /
              {{ item.breed }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-pagination
      v-model="pageNum"
      :length="pages"
      :total-visible="5"
      circle
      color="success"
      class="mt-2"
    />
  </div>
</template>
<script>
import { findExperiments } from '@/api/experiment.js'
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 8,
      pages: 0,
      selected: undefined,
      experiments: []
    }
  },
  mounted() {
    this.refresh()
  },
  watch: {
    selected(n, o) {
      console.log('selected:: ', n)
      this.$emit('selected', n)
      // if (n) {
      //   findExperimentSummaryById(n.id).then(resp => {
      //     this.$set(this.selectedItem, 'summary', resp)
      //   })
      //   this.$nextTick(() => {
      //     // this.$refs.detail.setExperimentId(n.id)
      //   })
      // }
    },
    pageNum(num) {
      this.selected = undefined
      this.refresh()
    }
  },
  methods: {
    refresh() {
      findExperiments(this.pageNum, this.pageSize).then(resp => {
        this.pages = resp.pages
        this.experiments = resp.list
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/history/HistoryIndexList.vue